var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.purchaseOption
    ? _c(
        "v-btn",
        {
          class: [
            "px-0 avatar-btn",
            _vm.$vuetify.breakpoint.width >= 375 ? "justify-start" : null,
          ],
          attrs: { color: "dark", outlined: "", text: "", block: "" },
          on: {
            click: function ($event) {
              return _vm.$emit("input", _vm.purchaseOption)
            },
          },
        },
        [
          _c("SoliStatusAvatar", {
            staticClass: "avatar-blue-border",
            attrs: {
              purchaseOption: _vm.purchaseOption,
              event: {},
              noShadow: "",
              size: "55",
              margin: "mr-6",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-col" },
            [
              _c(
                "v-list-item-title",
                {
                  class: [
                    "font-bold",
                    _vm.$vuetify.breakpoint.width >= 375 ? "flex" : null,
                  ],
                  staticStyle: {
                    "text-transform": "none",
                    "line-height": "18px",
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.purchaseOption.recipient.first_name +
                        "'s " +
                        _vm.purchaseOption.name
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-list-item-subtitle",
                {
                  class:
                    _vm.$vuetify.breakpoint.width < 375
                      ? "justify-center"
                      : "justify-start",
                  staticStyle: {
                    "text-transform": "none",
                    display: "flex",
                    "line-height": "18px",
                  },
                },
                [
                  _vm._v(
                    _vm._s(`${_vm.purchaseOption.location.name}
                ${
                  _vm.purchaseOption.category == "drop-ins" &&
                  _vm.purchaseOption.passes
                    ? " | " + _vm.purchaseOption.passes + " remaining"
                    : ""
                }`) + "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }